import React from "react";
const Home = React.lazy( () => import('../components/client/Home') )
const Dashboard = React.lazy( () => import('../components/admin/Dashboard') )
const Users = React.lazy( () => import('../components/admin/users/Users') )
const Roles = React.lazy( () => import('../components/admin/users/roles/Roles') )
const Pages = React.lazy( () => import('../components/admin/pages/Pages') )
const Profile = React.lazy(() => import('../components/admin/users/Profile'))
const Properties = React.lazy(() => import('../components/admin/properties/Properties'))
const Lease = React.lazy(() => import('../components/admin/leases/Lease'))
const ViewLease = React.lazy(() => import('../components/admin/leases/ViewLease'))
const RentInvoice = React.lazy(() => import('../components/admin/leases/RentInvoice'))
const BuyReport = React.lazy(() => import('../components/client/report/BuyReport'))
const CreateLease = React.lazy(() => import('../components/client/leases/CreateLease'))
const Search = React.lazy(() => import('../components/client/report/Search'))
const LeaseStart = React.lazy(() => import('../components/client/leases/Search'))
const Orders = React.lazy(() => import('../components/client/report/Orders'))
const OrderDetails = React.lazy(() => import('../components/client/report/OrderDetails'))
const Login = React.lazy(() => import('../components/admin/account/Login'))
const CreateAccount = React.lazy(() => import('../components/admin/account/CreateAccount'))
const Packages = React.lazy(() => import('../components/admin/packages/Packages'))
const Subscriptions = React.lazy(() => import('../components/subscriptions/Subscription'))
const ViewSubscription = React.lazy(() => import('../components/subscriptions/ViewSubscription'))
const SubscriptionInvoice = React.lazy(() => import('../components/subscriptions/SubsriptionInvoice'))
const Subscribe = React.lazy(() => import('../components/subscriptions/Subscribe'))
const PaySubscription = React.lazy(() => import('../components/subscriptions/PaySubscription'))
const Currencies = React.lazy(() => import('../components/admin/currencies/Currencies'))
const Settings = React.lazy(() => import('../components/admin/settings/Settings'))
const Contact = React.lazy(() => import('../components/client/Contact/Contact'))

const routes = [
	{path: '/', name: 'Home', exact:true, component: Home},
	{path: '/login', name: 'Login', exact:true, component: Login},
	{path: '/create-account', name: 'Create Account', exact:true, component: CreateAccount},
	{path: '/profile', name: 'Profile', exact:true, component: Profile},
	{path: '/admin', name: 'Dashboard', exact:true, component: Dashboard},
	{path: '/admin/users', name: 'Users', exact:true, component: Users},
	{path: '/admin/roles', name: 'Roles', exact:true, component: Roles},
	{path: '/admin/pages', name: 'Pages', exact:true, component: Pages},
	{path: '/admin/properties', name: 'Properties', exact:false, component: Properties},
	{path: '/admin/leases', name: 'Leases', exact:true, component: Lease},
	{path: '/admin/leases/:id', name: 'View Lease', exact:true, component: ViewLease},
	{path: '/admin/rent-invoice/:id', name: 'View Rent Invoice', exact:true, component: RentInvoice},
	{path: '/leases', name: 'Leases', exact:true, component: Lease},
	{path: '/leases/start', name: 'Create New Lease - Select User', exact:true, component: LeaseStart},
	{path: '/leases/create/:id', name: 'Create New Lease - Lease Terms', exact:true, component: CreateLease},
	{path: '/leases/:id', name: 'View Lease', exact:true, component: ViewLease},
	{path: '/properties', name: 'Properties', exact:false, component: Properties},
	{path: '/buy-report', name: 'Buy Report', exact:true, component: Search},
	{path: '/buy-report/:id', name: 'Buy Report', exact:false, component: BuyReport},
	{path: '/orders', name: 'My Orders', exact:true, component: Orders},
	{path: '/admin/orders', name: 'Orders', exact:true, component: Orders},
	{path: '/orders/:id', name: 'Order Details', exact:true, component: OrderDetails},
	{path: '/admin/orders/:id', name: 'Order Details', exact:true, component: OrderDetails},
	{path: '/admin/subscription/packages', name: 'Subscription Packages', exact:true, component: Packages},
	{path: '/admin/subscription', name: 'Subscription Users', exact:true, component: Subscriptions},
	{path: '/admin/subscription/:id', name: 'View Subscription', exact:true, component: ViewSubscription},
	{path: '/admin/subscription/:id/invoice/:invoiceId', name: 'View Subscription Invoice', exact:true, component: SubscriptionInvoice},
	{path: '/subscribe/:packageId', name: 'Subscribe', exact:true, component: Subscribe},
	{path: '/subscription/pay/:id', name: 'Pay Subscription', exact:true, component: PaySubscription},
	{path: '/subscription', name: 'Subscription Users', exact:true, component: Subscriptions},
	{path: '/subscription/:id', name: 'View Subscription', exact:true, component: ViewSubscription},
	{path: '/admin/currencies', name: 'Currencies', exact:true, component: Currencies},
	{path: '/admin/settings', name: 'Settings', exact:true, component: Settings},
	{path: '/contact', name: 'Contact', exact:true, component: Contact}
]

export default routes